import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'

export default function addressFieldBuilder({ rawField }: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  return {
    enableAutoPosition: !!rawField.enableAutoPosition,
  }
}
